import { render, staticRenderFns } from "./ChangeOwnerShipModal.vue?vue&type=template&id=d7630f7c&"
import script from "./ChangeOwnerShipModal.vue?vue&type=script&lang=js&"
export * from "./ChangeOwnerShipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports